import './types'

/*==================================
  共通処理
===================================*/
/*  ===== 用途タグ保持（初期データ） ===== */
let categoryInfoInitialData = {}

/**
 * 初期データをセット
 *
 * @param {CategoryFormData[]} categoryInitData - 用途タグ（初期データ）
 */
export function setCategoryInfoInitialData(categoryInitData) {
  categoryInfoInitialData = Object.fromEntries(categoryInitData.map((item) => [item.id, item]))
}

/**
 * CategoryNameをキーに初期データを取得
 *
 * @param {string} categoryName - 用途タグ名
 * @returns {CategoryFormData | null} 用途タグ設定（初期データ）またはnull
 */
export function getInitialDataByCategoryName(categoryName) {
  return categoryInfoInitialData[categoryName] || null
}

/** 初期データクリア */
function clearInitialData() {
  categoryInfoInitialData = {}
}

// アンマウント時などに初期データクリア
export function handleBeforeUnload() {
  clearInitialData()
}
